'use client';

import { c as _c } from "react/compiler-runtime";
import { Tabs, TabsList, TabsTrigger } from '@achra/ui/tabs';
import { UTCDate } from '@date-fns/utc';
import { format } from 'date-fns';
import { useQueryState } from 'nuqs';
import { useMemo } from 'react';
import { actualAccountTabSearchParamParser } from '@/modules/expense-reports/lib/search-params-client';
import { toKebabCase } from '@/modules/expense-reports/lib/strings';
import type { InnerTableRow } from '@/modules/expense-reports/types';
import { AdvancedInnerTable } from '../../advanced-inner-table/advanced-inner-table';
import { EmptyTablePlaceholder } from '../../advanced-inner-table/empty-table-placeholder';
import { BREAKDOWN_COLUMNS } from './breakdown-columns';
const ACTUALS_ACCOUNT_PARAM = 'actuals-account';
interface BreakdownActualsSectionProps {
  currentMonth: Date;
  hasMainTableItems: boolean;
  breakdownTabs: string[];
  breakdownItemsByWallet: InnerTableRow[][];
  builderLabel: string;
}
function BreakdownActualsSection(t0) {
  const $ = _c(29);
  const {
    currentMonth,
    hasMainTableItems,
    breakdownTabs,
    breakdownItemsByWallet,
    builderLabel
  } = t0;
  let t1;
  if ($[0] !== breakdownTabs) {
    t1 = breakdownTabs.map(_temp);
    $[0] = breakdownTabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const headerIds = t1;
  const defaultTabId = headerIds[0] ?? "";
  const [actualsAccount, setActualsAccount] = useQueryState(ACTUALS_ACCOUNT_PARAM, actualAccountTabSearchParamParser);
  let t2;
  if ($[2] !== actualsAccount || $[3] !== defaultTabId || $[4] !== headerIds) {
    t2 = actualsAccount && headerIds.includes(actualsAccount) ? actualsAccount : defaultTabId;
    $[2] = actualsAccount;
    $[3] = defaultTabId;
    $[4] = headerIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const activeTab = t2;
  let t3;
  if ($[6] !== defaultTabId || $[7] !== setActualsAccount) {
    t3 = value => {
      setActualsAccount(value === defaultTabId ? null : value);
    };
    $[6] = defaultTabId;
    $[7] = setActualsAccount;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleTabChange = t3;
  let t4;
  if ($[9] !== activeTab || $[10] !== headerIds) {
    t4 = headerIds.indexOf(activeTab);
    $[9] = activeTab;
    $[10] = headerIds;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const activeIndex = Math.max(0, t4);
  let t5;
  if ($[12] !== activeIndex || $[13] !== breakdownItemsByWallet) {
    t5 = breakdownItemsByWallet[activeIndex] ?? [];
    $[12] = activeIndex;
    $[13] = breakdownItemsByWallet;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const items = t5;
  let t6;
  if ($[15] !== currentMonth || $[16] !== hasMainTableItems) {
    t6 = hasMainTableItems && <h2 className="text-lg/[120%] font-bold">Actuals - {format(new UTCDate(currentMonth), "MMM yyyy")} Breakdown</h2>;
    $[15] = currentMonth;
    $[16] = hasMainTableItems;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== activeTab || $[19] !== breakdownTabs || $[20] !== builderLabel || $[21] !== handleTabChange || $[22] !== hasMainTableItems || $[23] !== headerIds || $[24] !== items) {
    t7 = hasMainTableItems && <div className="flex flex-col gap-6"><Tabs value={activeTab} onValueChange={handleTabChange} className="w-[400px]"><TabsList aria-label="Breakdown categories">{breakdownTabs.map((header_0, index_0) => <TabsTrigger key={headerIds[index_0]} value={headerIds[index_0]}>{header_0 || `Wallet ${index_0 + 1}`}</TabsTrigger>)}</TabsList></Tabs><div><AdvancedInnerTable columns={BREAKDOWN_COLUMNS} items={items} longCode={builderLabel} cardSpacingSize="small" tablePlaceholder={<EmptyTablePlaceholder actorName={builderLabel} />} /></div></div>;
    $[18] = activeTab;
    $[19] = breakdownTabs;
    $[20] = builderLabel;
    $[21] = handleTabChange;
    $[22] = hasMainTableItems;
    $[23] = headerIds;
    $[24] = items;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t6 || $[27] !== t7) {
    t8 = <div className="flex flex-col gap-4">{t6}{t7}</div>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
}
function _temp(header, index) {
  return toKebabCase(header) || `wallet-${index}`;
}
export { BreakdownActualsSection };